/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import { connect, useSelector } from 'react-redux'
import { Outlet, Navigate, useLocation } from 'react-router-dom'
import PropTypes from 'prop-types'
import { getProfile } from '../../service/actions/profileActions'
import { getCookie } from '../../components/helper'
// import { profileRequest } from '../../service/actions/userActions'

const PrivateRoute = ({ notAccessed, getUserProfile }) => {
  const errorProfile = useSelector((state) => state.profileReducer.ErrorProfile)
  const [isAuthenticated, setIsAuthenticated] = useState(true)
  const location = useLocation()

  useEffect(() => {
    // getUserProfile()
    const portalTokenExpiration = localStorage.getItem("dsTokenExpiration")
    if (portalTokenExpiration) {

      if (parseInt(portalTokenExpiration) * 1000 > Date.now()) {
        setIsAuthenticated(true)
      } else {
        setIsAuthenticated(false)

      }
    } else {
      localStorage.setItem("unAuthenticatedLink", location.pathname)
      setIsAuthenticated(false)

    }
  }, [location.pathname])

  // useEffect(() => {

  //   if (errorProfile !== '') {
  //     // localStorage.removeItem("portalUser")
  //     // localStorage.removeItem("token")

  //     // window.location = "/#/login"
  //   }
  // }, [errorProfile])


  // return (localStorage.getItem('portalUser') || (getCookie("token") && JSON.parse(getCookie("token")).access_token)) ? (

  return isAuthenticated ? (
    // true
    <Outlet />
  ) : (
    <Navigate to="/login" />
  )
}
PrivateRoute.propTypes = {
  getUserProfile: PropTypes.func,
  notAccessed: PropTypes.bool,
}
const mapStateToProps = (state) => ({
  notAccessed: state.userReducer.error,
  errorProfile: state.profileReducer.ErrorProfile
})

const mapDispatchToProps = (dispatch) => ({
  getUserProfile: () => dispatch(getProfile()),
})

export default connect(mapStateToProps, mapDispatchToProps)(PrivateRoute)
